export const hasFieldError = (field, errors) => errors.indexOf(field) > -1;
